import cliente_model from '@/shared/models/cliente_model';
import estado_solicitud_model from '@/shared/models/estado_solicitud_model';
import moneda_model from '@/shared/models/moneda_model';
import unidad_medida_model from '@/shared/models/unidad_medida_model';
import usabilidad_model from '@/shared/models/usabilidad_model';
import work_order_cantidad_model from './work_order_cantidad_model';
import work_order_elemento_model from './work_order_elemento_model';
import work_order_producto_model from './work_order_producto_model';

export default {
  Codigo: null,
  CodigoCotizacion: null,
  NumeroPedido: null,
  OrdenCompra: null,
  CodigoEstado: null,
  FechaEstado: null,
  CodigoCliente: null,
  Observaciones: null,
  ObservacionesProduccion: null,
  ObservacionesCotizacion: null,
  Notas: null,
  CodigoUnidadVenta: null,
  Referencia: null,
  CodigoUsabilidad: null,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  ToleranciaMinima: null,
  ToleranciaMaxima: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  Estado: { ...estado_solicitud_model, Codigo: 1 },
  Cliente: { ...cliente_model },
  Moneda: { ...moneda_model },
  UnidadVenta: { ...unidad_medida_model },
  OrdenProduccionCantidad: [{ ...work_order_cantidad_model, ItemCantidad: 1 }],
  OrdenProduccionClientes: [],
  OrdenProduccionAdjunto: [],
  OrdenProduccionProducto: [{ ...work_order_producto_model, ItemProducto: 1 }],
  OrdenProduccionElemento: [{ ...work_order_elemento_model, ItemElemento: 1 }],
  OrdenProduccionEntregas: [],
  Usabilidad: { ...usabilidad_model },
  ImportacionPedidoCantidadOP: [],
};
